module.exports = __webpack_public_path__ + "static/media/error.69e46133.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error.svg
// module id = 686
// module chunks = 0